import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCandidateAppliedJobs } from "store/slices/admin/candidate/candidate-details-slice";
import { tableStyle, thStyle, tdStyle, rowHoverStyle} from "./CandidateDetails.styled"
export const CandidateAppliedJobsTable = ({ candidateId }) => {
  const dispatch = useDispatch();
  const { candidateAppliedJobs = [] } = useSelector(
    (state) => state.candidate.adminCandidateSlice
  );
  useEffect(() => {
    if (candidateId) {
      dispatch(fetchCandidateAppliedJobs({ candidateId }));
    }
  }, [candidateId, dispatch]);
  return (
    <div>
      <h3 style={{ fontSize: "1.2rem", marginBottom: "0.5rem" }}>Candidate Applied Jobs</h3>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Job Name</th>
            <th style={thStyle}>Match Score</th>
            <th style={thStyle}>Fit Score</th>
          </tr>
        </thead>
        <tbody>
          {candidateAppliedJobs.map((appliedJob, idx) => (
            <tr
              key={idx}
              style={{
                ...rowHoverStyle,
                backgroundColor: idx % 2 === 0 ? "#fff" : "#F9F9F9",
              }}
            >
              <td style={tdStyle}>{appliedJob.job_name}</td>
              <td style={tdStyle}>{appliedJob.match_score}</td>
              <td style={tdStyle}>{appliedJob.fit_score}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};






